// extracted by mini-css-extract-plugin
export default {"notFound":"style_notFound__Rk-w5"};